import JSONApiService from "@/services/JSONApiService";
import { CONVERSATION_MODEL } from "@/models/conversation-model";
import { MESSAGE_TEMPLATE_MODEL } from "@/models/message-template-model";
import { CONVERSATION_MESSAGE_MODEL } from "@/models/conversation-message-model";
import {
  nested,
  include,
  SENDER,
  RECIPIENT,
  LAST_MESSAGE,
  BOOKING,
  MESSAGES
} from "@/models/relationships";
import APIService from "@/services/APIService";
import pluralize from "pluralize";

const conversationApi = commit => ({
  getConversations: async params =>
    JSONApiService(commit)
      .all(CONVERSATION_MODEL)
      .get({
        ...params,
        ...include(nested(LAST_MESSAGE, SENDER), RECIPIENT)
      }),
  getConversation: async id =>
    JSONApiService(commit)
      .one(CONVERSATION_MODEL, id)
      .get(include(nested(MESSAGES, SENDER), RECIPIENT)),
  getBookingMessageTemplates: async bookingId =>
    JSONApiService(commit)
      .one(BOOKING, bookingId)
      .all(MESSAGE_TEMPLATE_MODEL)
      .get(),
  getMessageTemplates: async params =>
    JSONApiService(commit)
      .all(MESSAGE_TEMPLATE_MODEL)
      .get(params),
  createConversation: async data =>
    JSONApiService(commit)
      .all(CONVERSATION_MODEL)
      .post(data, include(LAST_MESSAGE)),
  createConversationMessage: async data =>
    JSONApiService(commit)
      .all(CONVERSATION_MESSAGE_MODEL)
      .post(data, include(SENDER)),
  editConversation: async (id, data) =>
    JSONApiService(commit)
      .one(CONVERSATION_MODEL, id)
      .patch(data),
  createConversationMessageFile: async (id, data) =>
    APIService.client().postFile(
      `${pluralize(CONVERSATION_MESSAGE_MODEL)}/${id}/file`,
      data
    )
});

export default conversationApi;
